import script from "./AllMediaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AllMediaPage.vue?vue&type=script&setup=true&lang=js"

import "./AllMediaPage.vue?vue&type=style&index=0&id=39fe6e8e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39fe6e8e"]])

export default __exports__